import styled, { CSSObject } from 'styled-components';

export const defaultContainerStyle: CSSObject = {};
export const TableContainer = styled.div(defaultContainerStyle);
